import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Login';
import Dashboard from "./Dashboard";
import ForgotPassword from "./ForgotPasswordPage";
import "./theme/themes.css"
import { useNavigate } from "react-router-dom";

function App() {
  const navigate = useNavigate();
   return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/ForgotPassword" element={<ForgotPassword onNavigateToLogin={() => navigate("/login")} />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default App;